<template>
  <b-modal
    id="deleteTypeFlyerModal" 
    ref="deleteTypeFlyerModal" 
    no-close-on-backdrop
    centered
    v-model="showModal" 
    title="Apagar panfleto" 
    hide-footer
    size="lg"
  >
    <b-row>
      <b-col align="center" cols="12">
        <h4 class="text-center">Deseja realmente Excluir o panfleto {{ dataDelete.title}}?</h4>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col cols="12" md="6">
        <b-button @click="closeModal()" variant="outline-warning" block>Cancelar</b-button>
      </b-col>
      <b-col cols="12" md="6">
        <b-button @click="deleteFlyer()" variant="danger" block>Apagar</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import NewProductSmallWindow from '@/views/lojista/products/NewProductSmallWindow.vue';

export default {
  name: 'DeleteFlyerModal',
  emits: ['flyerDelete'],

  data() {
    return {
      loading: false,
      showModal: false,
      dataDelete: [],
    };
  },
  methods: {
    toggleOpen({ data = null }) {
      this.dataDelete = data;
      this.showModal = !this.showModal;
    },
    deleteFlyer() {
      this.$emit('flyerDelete', this.dataDelete.id);
      this.closeModal();
    },
    closeModal() {
      this.showModal = !this.showModal;
    },
  },
};
</script>
